








































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import FileModel from '@/store/models/FileModel';
import ProjectFileLink from '@/store/models/ProjectFileLink';
import ThePreview from '@/components/ThePreview.vue';
import { download, transform } from '@/core/download';
import { files, currentProject } from '@/core/storeUtils';
import { File, AddFileButton, FileMenu } from './Components';
import { ProjectTitle, HowToUse, NewFileInput } from './Pages';
import CodePane from '../CodePane/TheCodePane.vue';

@Component({
  components: {
    AddFileButton,
    File,
    FileMenu,
    ProjectTitle,
    HowToUse,
    NewFileInput,
  },
})
export default class TheFileExplorer extends Vue {
  private showNewFileInput = false;

  private snackbar = false;

  private downloadFile = (filename: string, code: string, type: string) => {
    const projectFiles = files(this.$store, currentProject(this.$store));
    const transformedCode = transform(type, code, projectFiles);
    download(filename, transformedCode);
  }

  private openNewFileInputField() {
    this.showNewFileInput = true;
    // FIXME: sloppy solution, just for functionality
    setTimeout(() => {
      (document.getElementById('new-file-input') as HTMLElement).focus();
    });
  }

  private deleteFile(event: MouseEvent, filename: string) {
    event.stopPropagation();
    this.$store.dispatch('fileExplorer/deleteFile', filename);
    (this.$root.$refs.Preview as ThePreview).showPreview();
  }

  private chooseFile(filename: string) {
    this.$store.dispatch('fileExplorer/updateSelectedFile', filename);
    const { editor } = this.$root.$refs.CodePane as CodePane;
    editor.focus();
    // FIXME: sloppy solution, just for functionality
    setTimeout(() => {
      editor.setCursor(editor.lineCount(), 0);
    });
  }

  private get myCurrentProject(): ProjectFileLink {
    return currentProject(this.$store);
  }

  private get myFiles(): Array<FileModel> {
    return files(this.$store, currentProject(this.$store));
  }
}
